import { render, staticRenderFns } from "./SearchPageHotelCardRightBlockSearchTimer.vue?vue&type=template&id=061630f0&scoped=true"
import script from "./SearchPageHotelCardRightBlockSearchTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageHotelCardRightBlockSearchTimer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchPageHotelCardRightBlockSearchTimer.vue?vue&type=style&index=0&id=061630f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061630f0",
  null
  
)

export default component.exports